<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>Properties</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details>
      </v-text-field> -->
      <v-tooltip bottom>
        <v-btn to="/property/property" slot="activator" color="primary" dark class="mb-2">Add Property</v-btn>
        <span>Create a New Property</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table flat :headers="headers" :items="recordList" :search="search" class="elevation-1" hide-actions>
      <template v-slot:items="props">
        <td>{{ props.item.data().nickname }}</td>        
        <td>{{ props.item.data().address }}</td>
        <td class="text-xs-left">{{ props.item.data().city }}</td>
        <td class="text-xs-left">{{ props.item.data().state }}</td>
        <td class="text-xs-left">{{ props.item.data().zip }}</td>
        <td class="text-xs-left">{{ props.item.data().lastUpdated | usDate }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip bottom>
            <v-icon @click="View(props.item)" slot="activator" small class="mt-3 mr-2">
              edit
            </v-icon>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon @click="Expenses(props.item)" slot="activator" small class="mt-3 mr-2">
              monetization_on
            </v-icon>
            <span>Expenses</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon @click="Inventory(props.item)" slot="activator" small class="mt-3 mr-2">
              widgets
            </v-icon>
            <span>Inventory</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon slot="activator" small class="mt-3 mr-2">
              assignment_turned_in
            </v-icon>
            <span>Maintenance Tasks</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-icon slot="activator" small class="mt-3 mr-2">
              add_alert
            </v-icon>
            <span>Manage Alerts</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        NO PROPERTIES FOUND
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </div>
</template>

<script>
  import db from '../../firebaseInit';

  export default {
    name: 'PropertyList',
    data() {
      return {
        search: '',
        recordList: [],
        headers: [
          { text: 'Nickname', value: 'nickname', sortable: false },
          { text: 'Address', value: 'address', sortable: false },
          { text: 'City', value: 'city', sortable: false },
          { text: 'State', value: 'state', sortable: false },
          { text: 'Zip', value: 'zip', sortable: false },
          { text: 'Last Updated', value: 'timestamp', sortable: false },
          { text: 'Actions', align: 'center', sortable: false  }
        ]
      }
    },
    methods: {
      GetRecords(){
        db.collection("properties").where("userName", "==", this.userName).get().then((querySnapshot) => {
          this.recordList = querySnapshot.docs;  
        });
      },
      View(item) {
        //set the selected report
        this.$router.push({ name: 'property', params: { id: item.id } });
      },
      Expenses(item){
        this.$store.commit('setCurrentProperty', item.data().nickname);
        this.$router.push({ name: 'expenseList', params: { id: item.id } });
      },
      Inventory(item){
        this.$store.commit('setCurrentProperty', item.data().nickname);
        this.$router.push({ name: 'inventoryList', params: { id: item.id } });
      }
    },
    computed: {
      userName(){
        return this.$store.state.user.userName;
      }
    },
    created: function() {
      this.recordList = [];
      this.GetRecords();
    }
  }
</script>

<style scoped>
</style>